export default __webpack_public_path__ + "static/media/tool-icon-shirt-black-02.35645730.svg";